import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
import CareersPage from '../pages/careers/page';
import CulturePage from '../pages/careers/culture/page';
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));

const EnterpriseCloudMigrationPage = lazy(() => import('../pages/case-studies/enterprise-cloud-migration/page'));
const CybersecurityImplementationPage = lazy(() => import('../pages/case-studies/cybersecurity-implementation/page'));
/* Renamed to avoid duplicate declaration */
const DigitalTransformationCasePage = lazy(() => import('../pages/case-studies/digital-transformation/page'));

const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Blog post pages
const CloudFuturePage = lazy(() => import('../pages/blog/posts/cloud-future'));
const RemoteSecurityPage = lazy(() => import('../pages/blog/posts/remote-security'));
const DigitalSuccessPage = lazy(() => import('../pages/blog/posts/digital-success'));
const AIBusinessPage = lazy(() => import('../pages/blog/posts/ai-business'));
const ZeroTrustPage = lazy(() => import('../pages/blog/posts/zero-trust'));
const CloudCostPage = lazy(() => import('../pages/blog/posts/cloud-cost'));
const LowCodePage = lazy(() => import('../pages/blog/posts/low-code'));
const K8sSecurityPage = lazy(() => import('../pages/blog/posts/k8s-security'));
const EdgeComputingPage = lazy(() => import('../pages/blog/posts/edge-computing'));

// Service detail pages
const CloudSolutionsPage = lazy(() => import('../pages/services/cloud-solutions/page'));
const CybersecurityPage = lazy(() => import('../pages/services/cybersecurity/page'));
const DigitalTransformationPage = lazy(() => import('../pages/services/digital-transformation/page'));
const ITInfrastructurePage = lazy(() => import('../pages/services/it-infrastructure/page'));
const DataAnalyticsPage = lazy(() => import('../pages/services/data-analytics/page'));
const DevOpsSolutionsPage = lazy(() => import('../pages/services/devops-solutions/page'));
const DevOpsSolutionsSolutionsPage = lazy(() => import('../pages/services/devops-solutions-solutions/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/cloud-solutions',
    element: <CloudSolutionsPage />,
  },
  {
    path: '/services/cybersecurity',
    element: <CybersecurityPage />,
  },
  {
    path: '/services/digital-transformation',
    element: <DigitalTransformationPage />,
  },
  {
    path: '/services/it-infrastructure',
    element: <ITInfrastructurePage />,
  },
  {
    path: '/services/data-analytics',
    element: <DataAnalyticsPage />,
  },
  {
    path: '/services/devops-solutions',
    element: <DevOpsSolutionsPage />,
  },
  {
    path: '/services/devops-solutions-solutions',
    element: <DevOpsSolutionsSolutionsPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/cloud-future',
    element: <CloudFuturePage />,
  },
  {
    path: '/blog/remote-security',
    element: <RemoteSecurityPage />,
  },
  {
    path: '/blog/digital-success',
    element: <DigitalSuccessPage />,
  },
  {
    path: '/blog/ai-business',
    element: <AIBusinessPage />,
  },
  {
    path: '/blog/zero-trust',
    element: <ZeroTrustPage />,
  },
  {
    path: '/blog/cloud-cost',
    element: <CloudCostPage />,
  },
  {
    path: '/blog/low-code',
    element: <LowCodePage />,
  },
  {
    path: '/blog/k8s-security',
    element: <K8sSecurityPage />,
  },
  {
    path: '/blog/edge-computing',
    element: <EdgeComputingPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/careers/culture',
    element: <CulturePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/case-studies/enterprise-cloud-migration',
    element: <EnterpriseCloudMigrationPage />,
  },
  {
    path: '/case-studies/cybersecurity-implementation',
    element: <CybersecurityImplementationPage />,
  },
  {
    path: '/case-studies/digital-transformation',
    /* Updated element to use the renamed component */
    element: <DigitalTransformationCasePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;